/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminRebuildBracketBody
 */
export interface AdminRebuildBracketBody {
    /**
     * Why the bracket is being regenerated. Recorded in the audit log.
     * @type {string}
     * @memberof AdminRebuildBracketBody
     */
    reason: string;
}

/**
 * Check if a given object implements the AdminRebuildBracketBody interface.
 */
export function instanceOfAdminRebuildBracketBody(value: object): value is AdminRebuildBracketBody {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function AdminRebuildBracketBodyFromJSON(json: any): AdminRebuildBracketBody {
    return AdminRebuildBracketBodyFromJSONTyped(json, false);
}

export function AdminRebuildBracketBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminRebuildBracketBody {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

export function AdminRebuildBracketBodyToJSON(json: any): AdminRebuildBracketBody {
    return AdminRebuildBracketBodyToJSONTyped(json, false);
}

export function AdminRebuildBracketBodyToJSONTyped(value?: AdminRebuildBracketBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

